import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import TokenListingHero from "./TokenListingHero";
import TokenLSer from "./TokenLSer";
import DetailedListing from "./DetailedListing";

function TokenListing() {
  return (
    <div>
      <Header />
      <TokenListingHero />
      <TokenLSer />
      <DetailedListing />
      <Footer />
    </div>
  );
}

export default TokenListing;
